import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * タブの中身（`Tabs` の children として使う）。
 * params: label（必須, タブ見出し）、text（任意, joined）
 * children: 任意（配下ブロック）
 *
 * label は親 Tabs がタブ見出しに使う。本コンポーネントは中身のみ描画する。
 */
export const Tab: React.FC<KnzComponentProps> = ({ node, renderChildren, renderInline }) => {
  const text = node.params.text as string | undefined;
  return (
    <Stack spacing={1.5}>
      {text && (
        <Typography variant="body2" color="text.secondary" component="div" sx={{ lineHeight: 1.8 }}>
          {renderInline(text)}
        </Typography>
      )}
      {renderChildren(node.children)}
    </Stack>
  );
};

export default Tab;
